import React from 'react';
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { Divider } from 'legacyComponents/styled/lib';
import { Heading } from 'components';
import { OpCard } from 'apps/repository/contributionPage/views/opCard';
import {
  OpSectionWrapper,
  OpSectionTitle,
  ButtonExpand,
} from 'apps/repository/contributionPage/styles';

import { withNamespaces, Trans } from 'react-i18next';

class SectionState {
  @observable minimised = false;
  @action SetMinimised = bool => {
    this.minimised = bool;
  };
}

@withNamespaces()
@observer
export class OpSection extends React.Component {
  UNSAFE_componentWillMount() {
    this.sectionState = new SectionState();
  }

  render() {
    const { title, count, ops, contribution } = this.props;
    const { SetMinimised, minimised } = this.sectionState;

    const oppCards = ops.map(op => (
      <OpCard key={op.id} operation={op} contribution={contribution} />
    ));

    return (
      <OpSectionWrapper>
        <OpSectionTitle onClick={() => SetMinimised(!minimised)}>
          {title}
          <span>&nbsp;({count})</span>
        </OpSectionTitle>
        <ButtonExpand
          variant='secondary'
          icon={minimised ? 'add' : 'remove'}
          size='xsmall'
          onClick={() => SetMinimised(!minimised)}
          outline
        />
        <Divider width='100%' margin='10px auto' />
        {minimised ? (
          <Heading level={5}>
            (<Trans>Minimised</Trans>)
          </Heading>
        ) : (
          oppCards
        )}
      </OpSectionWrapper>
    );
  }
}

OpSection.propTypes = {
  title: PropTypes.string,
  count: PropTypes.number,
  ops: PropTypes.array,
  contribution: PropTypes.object,
};
